interface StarRatingProps {
  rating: number;
  size?: string;
  showValue?: boolean;
}

export default function StarRating({ rating, size = "text-sm", showValue = true }: StarRatingProps) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;

  return (
    <div className="flex items-center gap-1">
      <span className={`flex items-center ${size}`}>
        {Array.from({ length: 5 }).map((_, i) => {
          if (i < full) return <i key={i} className="ri-star-fill text-primary-500" />;
          if (i === full && hasHalf) return <i key={i} className="ri-star-half-fill text-primary-500" />;
          return <i key={i} className="ri-star-line text-background-300" />;
        })}
      </span>
      {showValue && <span className="text-xs font-bold text-foreground-700">{rating.toFixed(1)}</span>}
    </div>
  );
}